module.exports = __webpack_public_path__ + "img/main-facility-sports.765b524b.jpg";